import config from "config";
import { getEnvConfig } from "env";
import { useScadaPlusQuery } from "hooks/useScadaPlusQuery";
import React from "react";
import { useQueryClient } from "react-query";
import { GenericAlarmPriorityCounter } from "types";
export const useGetAlarmData = (
  componentUnitId: string,
  newAlarmData: unknown | null,
) => {
  const queryClient = useQueryClient();
  const alarmPrioritiesQueryName = `alarmPriorities-${componentUnitId}`;
  const { data: alarmPriorityData } = useScadaPlusQuery<
    Array<GenericAlarmPriorityCounter>
  >(
    alarmPrioritiesQueryName,
    `${getEnvConfig("API_URL") as string}/api/${config.api.genericAlarmPriorityCounters}?ComponentUnitId=${componentUnitId}`,
  );
  React.useEffect(() => {
    if (newAlarmData) {
      queryClient.invalidateQueries(alarmPrioritiesQueryName);
    }
  }, [newAlarmData, queryClient, alarmPrioritiesQueryName]);
  return alarmPriorityData;
};
